import { render, staticRenderFns } from "./TaskByBuilding.vue?vue&type=template&id=72c0f721&"
import script from "./TaskByBuilding.vue?vue&type=script&lang=js&"
export * from "./TaskByBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports